import React, { useState } from "react";
import ReactDOM from "react-dom";
import logoMascota from "../../../../assets/logo-mascota.png";
import FlappySurtidor from "./MascotaOculta"; 
import RunnerSurtidor from "./RunnerSurtidor";

export default function CentroArcade() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [juegoSeleccionado, setJuegoSeleccionado] = useState(null); 

  const cerrarTodo = () => {
    setJuegoSeleccionado(null);
    setMenuAbierto(false);
  };

  return (
    <>
      {/* BOTÓN FLOTANTE ÚNICO DEL ARCADE (ESQUINA INFERIOR DERECHA) */}
      {!menuAbierto && !juegoSeleccionado && ReactDOM.createPortal(
        <button 
          onClick={() => setMenuAbierto(true)} 
          className="fixed bottom-4 right-4 sm:right-6 z-[999999] group cursor-pointer transition-transform duration-300 hover:-translate-y-2"
        >
          <div className="bg-white/80 backdrop-blur-[25px] rounded-2xl sm:rounded-t-[28px] px-4 pt-3 pb-2 shadow-[0_10px_30px_rgba(0,0,0,0.25)] border border-white/90 flex items-center gap-2.5 relative">
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
            <img src={logoMascota} alt="Mascota" className="w-8 h-8 object-contain animate-bounce pointer-events-none drop-shadow-sm" />
            <span className="text-[11px] font-black uppercase tracking-widest text-slate-800 hidden sm:group-hover:inline-block">Arcade</span>
          </div>
        </button>,
        document.body
      )}

      {/* MENÚ DE SELECCIÓN GLASSMORPHISM */}
      {menuAbierto && !juegoSeleccionado && ReactDOM.createPortal(
        <div className="fixed inset-0 z-[999999] bg-slate-950/50 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-white/90 backdrop-blur-[50px] rounded-[36px] shadow-[0_30px_90px_rgba(0,0,0,0.2)] p-6 sm:p-8 border border-white/90 w-full max-w-sm relative">
            
            <button onClick={() => setMenuAbierto(false)} className="absolute top-4 right-4 bg-white/70 hover:bg-white w-9 h-9 rounded-full font-bold text-slate-700 transition z-50 text-sm shadow-md backdrop-blur-md border border-white flex items-center justify-center cursor-pointer hover:rotate-90 duration-300">✕</button>

            <div className="text-center mb-6 mt-2">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl mx-auto flex items-center justify-center mb-3 shadow-inner">
                <img src={logoMascota} alt="Icon" className="w-10 h-10 object-contain drop-shadow-sm" />
              </div>
              <h3 className="text-2xl font-black text-slate-800 uppercase tracking-tight">Arcade Surtidor</h3>
              <p className="text-slate-500 text-xs font-medium mt-1">Elige un minijuego para competir</p>
            </div>

            <div className="flex flex-col gap-4">
              <div 
                onClick={() => { setMenuAbierto(false); setJuegoSeleccionado('flappy'); }} 
                className="group p-1 rounded-2xl bg-gradient-to-r from-sky-400 to-blue-500 hover:shadow-lg hover:shadow-blue-500/30 transition-all cursor-pointer"
              >
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 flex items-center gap-4 h-full transition-transform group-hover:scale-[0.98]">
                  <div className="bg-sky-100 w-12 h-12 rounded-xl flex items-center justify-center text-2xl shadow-inner shrink-0 group-hover:animate-bounce">🐦</div>
                  <div>
                    <h4 className="font-black text-slate-800 text-base leading-none mb-1">Flappy Surtidor</h4>
                    <p className="text-[10px] text-slate-500 font-medium leading-tight">Esquiva los tubos y rompe tu récord.</p>
                  </div>
                </div>
              </div>

              <div 
                onClick={() => { setMenuAbierto(false); setJuegoSeleccionado('runner'); }} 
                className="group p-1 rounded-2xl bg-gradient-to-r from-emerald-400 to-green-500 hover:shadow-lg hover:shadow-emerald-500/30 transition-all cursor-pointer"
              >
                <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 flex items-center gap-4 h-full transition-transform group-hover:scale-[0.98]">
                  <div className="bg-emerald-100 w-12 h-12 rounded-xl flex items-center justify-center text-2xl shadow-inner shrink-0 group-hover:animate-bounce">🏃‍♂️</div>
                  <div>
                    <h4 className="font-black text-slate-800 text-base leading-none mb-1">Super Runner</h4>
                    <p className="text-[10px] text-slate-500 font-medium leading-tight">Recolecta frutas por los pasillos.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>,
        document.body
      )}

      {juegoSeleccionado === 'flappy' && <FlappySurtidor alCerrar={cerrarTodo} />}
      {juegoSeleccionado === 'runner' && <RunnerSurtidor alCerrar={cerrarTodo} />}
    </>
  );
}